<div class="loading-modal spinner-lg" *ngIf="loading"></div>